import React, { useEffect, useMemo, useState } from 'react';
import axios from 'axios';
import { Spinner } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import CuponsTab from '../components/marketing/CuponsTab';
import LandPageServicosTab from '../components/marketing/LandPageServicosTab';
import { useEntidadeContext } from '../EntidadeContext';
import { useUserContext } from '../UserContext';
import '../styles/marketing.css';

const TAB_ICONS = {
  mk_lp_servicos: 'globe',
  GestaoCupons: 'tag',
};

const MarketingPage = () => {
  const { currentEntidade } = useEntidadeContext();
  const { currentUserRole, getPermittedInternalTabs, isLoadingAccessConfig } = useUserContext();
  const [activeTab, setActiveTab] = useState('');
  const [servicos, setServicos] = useState([]);
  const [isLoadingServicos, setIsLoadingServicos] = useState(false);

  const permittedTabs = useMemo(
    () => getPermittedInternalTabs('marketing', currentUserRole),
    [currentUserRole, getPermittedInternalTabs]
  );

  useEffect(() => {
    if (isLoadingAccessConfig || permittedTabs.length === 0) return;

    if (!permittedTabs.some(tab => tab.key === activeTab)) {
      setActiveTab(permittedTabs[0].key);
    }
  }, [activeTab, isLoadingAccessConfig, permittedTabs]);

  useEffect(() => {
    if (activeTab !== 'mk_lp_servicos' || !currentEntidade?.id || servicos.length > 0) return;

    let isMounted = true;
    setIsLoadingServicos(true);

    axios.get(`/api/landpageservicos?entidade_id=${currentEntidade.id}`)
      .then(response => {
        if (isMounted) setServicos(response.data.servicos || []);
      })
      .catch(() => {
        if (isMounted) setServicos([]);
      })
      .finally(() => {
        if (isMounted) setIsLoadingServicos(false);
      });

    return () => {
      isMounted = false;
    };
  }, [activeTab, currentEntidade?.id, servicos.length]);

  if (isLoadingAccessConfig) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '50vh' }}>
        <Spinner animation="border" variant="primary" />
      </div>
    );
  }

  return (
    <div style={{ backgroundColor: '#f8fafc', minHeight: '100vh' }}>
      <div className="marketing-page-header" style={{
        backgroundColor: '#fff',
        borderBottom: '1px solid #e5e7eb',
        padding: '0 24px',
        display: 'flex',
        alignItems: 'center',
        height: '64px',
      }}>
        <div className="marketing-header-title" style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
          <div style={{
            width: '36px',
            height: '36px',
            borderRadius: '10px',
            background: 'linear-gradient(135deg, #3b82f6, #8b5cf6)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}>
            <FontAwesomeIcon icon="bullhorn" style={{ color: '#fff' }} />
          </div>
          <div>
            <h1 style={{ margin: 0, fontSize: '16px', fontWeight: 700 }}>Marketing</h1>
            {currentEntidade && (
              <p style={{ margin: 0, fontSize: '11px', color: '#9ca3af' }}>{currentEntidade.nome}</p>
            )}
          </div>
        </div>
      </div>

      <div className="marketing-mobile-navigation">
        <label htmlFor="marketing-mobile-section">Seção do Marketing</label>
        <select
          id="marketing-mobile-section"
          value={activeTab}
          onChange={event => setActiveTab(event.target.value)}
        >
          {permittedTabs.map(tab => (
            <option key={tab.key} value={tab.key}>{tab.title}</option>
          ))}
        </select>
      </div>

      <div className="marketing-desktop-navigation" style={{
        backgroundColor: '#fff',
        borderBottom: '1px solid #e5e7eb',
        padding: '0 24px',
        gap: '4px',
      }}>
        {permittedTabs.map(tab => (
          <button
            key={tab.key}
            type="button"
            onClick={() => setActiveTab(tab.key)}
            style={{
              padding: '12px 16px',
              border: 'none',
              background: 'none',
              cursor: 'pointer',
              fontWeight: activeTab === tab.key ? 600 : 400,
              color: activeTab === tab.key ? '#3b82f6' : '#6b7280',
              borderBottom: activeTab === tab.key ? '2px solid #3b82f6' : '2px solid transparent',
            }}
          >
            <FontAwesomeIcon icon={TAB_ICONS[tab.key] || 'circle'} style={{ marginRight: '6px' }} />
            {tab.title}
          </button>
        ))}
      </div>

      {activeTab === 'GestaoCupons' && (
        <div style={{ padding: '24px' }}>
          <CuponsTab currentUserRole={currentUserRole} />
        </div>
      )}

      {activeTab === 'mk_lp_servicos' && (
        <div style={{ padding: '24px' }}>
          <LandPageServicosTab initialServicos={servicos} isLoading={isLoadingServicos} />
        </div>
      )}
    </div>
  );
};

export default MarketingPage;
